module.exports = __webpack_public_path__ + "static/img/14003011.6814ca83.png";